import { accessRole } from "../../../../helpers/access_role"

import React, { Fragment, useState, useRef } from "react"
import classnames from "classnames"
import { Link } from "react-router-dom"

import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button,
    Nav,
    NavItem,
    NavLink,
    TabContent,
    TabPane
} from "reactstrap"

import TableActiveComponent from './Components/TablePrimaryComponent'
import PegawaiSideBar from '../../GlobalComponents/PegawaiSidebar';


const IndexView = (props) => {

    const [activeTab, setactiveTab] = useState("1")    
    const activeRef = useRef();
    const inactiveRef = useRef();

    const currentRoleId = JSON.parse(localStorage.getItem('currentRoleId'));

    const reloadActiveRef = () => activeRef.current.setTokenAPI()
    const reloadInactiveRef = () => activeRef.current.setTokenAPI()

    function toggle(tab) {
        if (activeTab !== tab) {
            setactiveTab(tab)
        }
    }

    return (
        <Fragment>
            <Container fluid>
                <Row>
                    <Col xs="12">

                        <PegawaiSideBar active="riwayatjabatan"/>

                        <Card className="pegawai-rightbar">
                            <CardBody>
                                <div className="float-end">
                                {/* {
                                    (accessRole('create')) && currentRoleId == 1 ?
                                        <Link to="?riwayatjabatan&create">
                                            <Button color="primary">Tambah Riwayat Jabatan</Button>
                                        </Link>
                                    : null
                                } */}
                                </div>
                                <CardTitle>Daftar Riwayat Jabatan</CardTitle>
                                <CardSubtitle className="mb-3">
                                    Kelola Daftar Riwayat Jabatan
                                </CardSubtitle>
                                <hr />
                                <TableActiveComponent ref={activeRef} handleInactiveSuccess={reloadInactiveRef}/>
                            </CardBody>
                        </Card>
                        
                    </Col>
                </Row>
            </Container>
        </Fragment>
    )
}

export default IndexView